"use client";
import { jsx, jsxs } from "react/jsx-runtime";
import styled from "styled-components";
const SVG = styled.svg`
  min-width: ${({ $size }) => $size};
  max-width: ${({ $size }) => $size};
  height: ${({ $size }) => $size};
`;
const AddNote = ({ size = "1em", color = "currentColor", title, ...props }) => /* @__PURE__ */ jsxs(SVG, { ...props, $size: size, viewBox: "0 0 24 24", xmlns: "http://www.w3.org/2000/svg", role: title ? "img" : "presentation", children: [
  title ? /* @__PURE__ */ jsx("title", { children: title }) : null,
  " ",
  /* @__PURE__ */ jsx("path", { fill: color, d: "M18.55 11.54a.75.75 0 1 1 1.5 0v9.76a1.75 1.75 0 0 1-1.75 1.75H2.75A1.75 1.75 0 0 1 1 21.3V5.75C1 4.784 1.783 4 2.75 4H12a.75.75 0 1 1 0 1.5H2.75a.25.25 0 0 0-.25.25V21.3c0 .138.112.25.25.25H18.3a.25.25 0 0 0 .25-.25v-9.76zm3.96-8.325c.685.684.682 1.794-.005 2.48l-1.232 1.233-1.06 1.06-7.851 7.851c-.482.482-1.341.993-1.994 1.186l-3.554 1.052a.749.749 0 0 1-.932-.932l1.051-3.555c.193-.653.705-1.512 1.186-1.993l7.851-7.851 1.06-1.061 1.233-1.232a1.754 1.754 0 0 1 2.48-.006l1.768 1.768zM11.535 14.571l7.63-7.63-2.12-2.122-7.632 7.631c-.286.286-.638.897-.744 1.293l-.83 2.377 2.402-.804c.396-.106 1.007-.458 1.294-.745zm6.57-10.813l2.121 2.122 1.247-1.247a.244.244 0 0 0-.01-.344L19.696 2.52a.244.244 0 0 0-.344-.01l-.354.354-.893.893z", children: " " })
] });
var AddNote_default = AddNote;
export {
  AddNote_default as default
};
